import React from 'react'

import { ArrowDownward, ArrowUpward } from '@mui/icons-material'

// Direction cue next to a signed change figure (2026-09-08 review: "green arrow
// up, red arrow down"). Purely decorative — the sign is already in the text
// ("+5%"), so it is aria-hidden and never part of the accessible name;
// otherwise every ranked-list row would announce "arrow upward".
//
// Plain arrows rather than the TrendingUp/Down pair the tiles already use as
// their faded corner watermark: repeating that glyph solid and small in the
// same tile reads as a duplicate, an arrow reads as a direction marker.
//
// Nothing is rendered for a flat or unknown change: an em dash or "±0" that
// sprouts an arrow claims a direction it doesn't have. `color` is the value's
// own accent, passed in so this never picks a color of its own.
export function deltaDirectionArrow(delta: number | null, color: string): React.ReactNode {
  if (delta === null || delta === 0) return null
  const Icon = delta > 0 ? ArrowUpward : ArrowDownward
  // `em` so the arrow scales with whichever value line it sits on, and
  // `verticalAlign` so it centers on the digits without growing the line box.
  return <Icon aria-hidden="true" sx={{ fontSize: '0.8em', verticalAlign: '-0.1em', color, mr: 0.25 }} />
}
